module.exports = __webpack_public_path__ + "img/required-icon.b2ea70b7.svg";